<template>
  <div>
    <div v-if="f_field.headline" class="mt-2 pt-0 mb-1">
      <v-flex
        style="background-color:#292929; color: #ddd; line-height:30px;"
        class="px-2 py-0 xs12"
      >
        <h3 class="font-weight-bold body-2 xs12 flex">
          {{ f_field.title }}
        </h3>
      </v-flex>
    </div>

    <div v-else-if="f_field.subheadline" class="mt-2 mb-1">
      <v-flex style="" class="px-2 pb-0 xs12">
        <h3 class="xs12 flex">
          {{ f_field.title }}
        </h3>
        <!-- <v-divider color='black'></v-divider> -->
      </v-flex>
    </div>

    <div
      v-if="
        f_field.component &&
          ([
            'deaccession_date',
            'comment_on_deaccession',
            'new_ownership',
            'deaccession_price_offer',
            'deaccession_price_paid',
            'invoice_deaccession_papers'
          ].includes(f_field.name)
            ? f_artwork.deaccessioned == 1
            : true)
      "
      class="mt-2 mb-2 mx-0"
    >
      <component
        :is="f_field.component"
        :uploadCategory="f_field.title"
        :artwork="f_artwork"
        :name="f_field.name"
        :field="f_field"
        :film="film"
      ></component>
    </div>

    <div v-else-if="f_artwork[f_field.name]" class="mt-0 py-0 mb-1 pl-2">
      <v-flex v-if="field_type == 'text-short'">
        <v-flex>
          <code>{{ f_artwork[f_field.name] }}{{ f_field.suffix }}</code>
          <!-- <label v-if="label != ''">{{ label }}</label> -->
          <label style="color:#999;">{{ f_field.title }}</label>
        </v-flex>
      </v-flex>

      <v-flex v-if="field_type == 'currency'" xs12 d-flex>
        <v-flex xs12 sm6>
          <code>{{ f_artwork[f_field.name] }} {{ f_artwork[`${f_field.name}_currency`] }}</code
          >
          <label>{{ hint }}</label>
        </v-flex>
      </v-flex>

      <v-flex v-else-if="this.field_type == 'text-long'">
        <!-- <label>{{label}}:</label> -->
        <code style="vertical-align:bottom;"
          >{{ f_artwork[f_field.name].trim() }} {{ f_artwork[`${f_field.name}_currency`] }}</code
        >
        <!-- style="color:#999; vertical-align: text-top; margin-right:5px;" -->
        <label>{{ f_field.title }}</label>
      </v-flex>

      <v-flex xs12 v-else-if="this.field_type == 'date'">
        <code>{{ f_artwork[f_field.name] }} </code>
        <label style="color:#999;">{{ f_field.title }}</label>
        <label v-if="f_field.title == ''">{{ label }}</label>
        <!-- {{select_value}} -->
      </v-flex>

      <v-flex v-else-if="this.field_type == 'bool'">
        <code>{{ f_artwork[f_field.name] ? 'Yes' : 'No' }}</code>
        <label class="black--text">{{ f_field.title }}</label>
      </v-flex>

      <v-flex v-else-if="this.field_type == 'radio'">
        <v-radio-group
          :label="`${f_field.title}`"
          :column="f_field.column ? f_field.column : false"
          :value="value_radio"
          :refs="f_field.name"
        >
          <v-radio
            v-for="s in f_field.selection"
            :label="s.name ? s.name : s"
            :value="s.value ? s.value : s"
            :key="s.id ? s.id : s"
            class="ml-3"
          ></v-radio>
        </v-radio-group>
        <label class="black--text">{{ f_field.title }}</label>
        {{ f_field.selection[value_radio] }}

        <v-flex
          class="xs12 elevation-3 py-3 px-3"
          v-if="f_field.name == 'sound' && this.value_new == '1'"
        >
          <v-flex c>
            Audio Codec
            <code>{{ film.audio_codec }}</code>
          </v-flex>
          <v-flex v-if="f_field.name == 'sound' && this.value_new == '1'">
            <v-label>Audio Resolution</v-label>
          </v-flex>
          <v-flex v-if="f_field.name == 'sound' && this.value_new == '1'">
            <v-label>Audio Bit</v-label>
            <code>{{ film.audio_bit }} </code>
          </v-flex>
          <v-flex v-if="f_field.name == 'sound' && this.value_new == '1'">
            <label>Channels</label>
            <code>{{ channels[id] }}</code>
          </v-flex>
          <v-flex v-if="f_field.name == 'sound' && this.value_new == '1'">
            <label>Audio Specs</label>
            <code>{{ f_artwork.sound }}</code>
          </v-flex>
        </v-flex>
      </v-flex>

      <v-flex v-else-if="this.field_type == 'checkbox'">
        <v-flex>
          <label class="sub-headline mt-3 ml-3">{{ f_field.title }}</label>
          <v-checkbox
            v-for="s in f_field.selection"
            hide-details
            :label="s.name ? s.name : s"
            :key="s.id ? s.id : s"
            disabled
            class="left mr-3 ml-3"
            :refs="f_field.name"
            >{{ s.name ? s.name : s }}</v-checkbox
          >
        </v-flex>
      </v-flex>

      <v-flex v-else-if="this.field_type == 'toggle'">
        <v-flex xs12 sm6 class="pt-0">
          <code>{{ toggle_value }}</code>
          <!-- <v-btn-toggle disabled v-model="toggle">
            <v-btn
              disabled
              small
              flat
              v-for="s in f_field.selection"
              :key="s.id ? s.value : s"
              class="px-2"
              :value="s.value"
            >
              <span
                :style="
                  s.value == f_artwork[f_field.name]
                    ? 'color: white;'
                    : 'color: black;'
                "
              >
                {{ s.name }}
              </span>
            </v-btn>
          </v-btn-toggle> -->
        <label>{{ f_field.title }}</label>
        </v-flex>
      </v-flex>

      <v-layout v-else-if="f_field.etype === 'select'" row wrap>
        <v-flex>
          <code>{{ select_item }}</code>
          <label>{{ f_field.title }}</label>

          <v-flex
            v-if="
              f_field.name == 'classification_new_id' &&
                this.select_value == 'film'
            "
          >
            <v-radio-group
              v-model="film.film_type"
              label="Select Film Type"
              row
            >
              <v-radio
                v-for="s in ['tape', 'film', 'digital born']"
                :label="s"
                :value="s"
                :key="s"
                class="ml-3"
              ></v-radio>
            </v-radio-group>
          </v-flex>

          <v-flex
            v-if="
              f_field.name == 'classification_new_id' &&
                this.select_value == 'inst'
            "
            class="xs12 mx-3"
          >
            <v-flex class="xs12 mx-3">
              <v-flex class="subheadline mt-4">Includes</v-flex>
              <v-checkbox
                v-for="s in [
                  'Objects',
                  'Sound',
                  'FilmVideoAV',
                  'Slide',
                  'Computer Program / Software / File',
                  'Performance',
                  'Light',
                  'Other'
                ]"
                v-model="instalation_includes"
                :key="s"
                :label="s"
                :value="s"
                hide-details
                xs12
                md6
                lg4
              ></v-checkbox>
            </v-flex>

            <v-flex
              v-if="this.instalation_includes.indexOf('FilmVideoAV') >= 0"
              class="xs12 mx-3"
            >
              <v-radio-group
                v-model="film.film_type"
                label="Select Film Type"
                row
              >
                <v-radio
                  v-for="s in ['tape', 'film', 'digital born']"
                  :label="s"
                  :value="s"
                  :key="s"
                  class="ml-3"
                ></v-radio>
              </v-radio-group>
            </v-flex>

            <v-flex
              v-if="this.instalation_includes.indexOf('Other') >= 0"
              class="xs12 mx-3"
            >
              <v-text-field
                v-model="film.film_type"
                class="ml-3"
                name="including_other"
                label="Other"
                row
              ></v-text-field>
            </v-flex>
          </v-flex>
        </v-flex>
        <!-- <v-flex v-if="this.showingAddForm && f_field.addNew">
        <add-artist v-if="f_field.table=='artists'" itemToAdd="f_field"></add-artist>
      </v-flex> -->
      </v-layout>

      <v-flex v-else-if="f_field.etype === 'autocomplete'">
        <code>{{ select_item }}</code>
        <label>{{ f_field.title }}</label>
      </v-flex>
    </div>
  </div>
</template>

<script>
// import EditFieldHeader from '@/components/artists/EditFieldHeader'
import ViewArtworks from '@/components/artists/ViewArtworks'
// import dynamic_fields from '@/data/dynamic_fields'
import fields from '@/data/full_user_fields'
import AddArtist from '@/components/artists/AddArtist'
import AddLocation from '@/components/locations/AddLocation'
import Upload from '@/components/artworks/Upload'
import Location from '@/components/artworks/Location'
import Electrical from '@/components/artworks/Electrical'
import MarketValueHistory from '@/components/artworks/MarketValueHistory'
import NonElectrical from '@/components/artworks/NonElectrical'
import Films from '@/components/artworks/Films'
import Audio from '@/components/artworks/Audio'
import Programme from '@/components/artworks/Programme'
import InformationCarrier from '@/components/artworks/InformationCarrier'
import Light from '@/components/artworks/Light'
import ReadingDevices from '@/components/artworks/ReadingDevices'
import Links from '@/components/artworks/Links'
import Costs from '@/components/artworks/Costs'
import LoanConditions from '@/components/artworks/LoanConditions'
import OwnershipHistory from '@/components/artworks/OwnershipHistory'
import Conservation from './Conservation'
import constants from '@/data/constants'
import Insurance from '@/components/artworks/Insurance'
import axios from 'axios'
import { mapState } from 'vuex'
import * as qs from 'querystring'

// import EditField from './EditField'

function dynamicSort(property) {
  var sortOrder = 1
  if (property[0] === '-') {
    sortOrder = -1
    property = property.substr(1)
  }
  return function(a, b) {
    var result =
      a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0
    return result * sortOrder
  }
}
function nl2br(str, is_xhtml) {
  var breakTag = is_xhtml || typeof is_xhtml === 'undefined' ? '<br />' : '<br>'
  return (str + '').replace(
    /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
    '$1' + breakTag + '$2'
  )
}

export default {
  name: 'read-field',
  channels: [
    { id: 1, value: '1', name: 'Single-channel' },
    { id: 2, value: '2', name: 'Two-channel' },
    { id: 3, value: '3', name: 'Three-channel' },
    { id: 4, value: '4', name: 'Four-channel' },
    { id: 5, value: '5', name: 'Five-channel' },
    { id: 6, value: '6', name: 'Six-channel' },
    { id: 7, value: '7', name: 'Seven-channel' },
    { id: 8, value: '8', name: 'Eight-channel' },
    { id: 9, value: '9', name: 'Nine-channel' },
    { id: 10, value: '10', name: 'Ten-channel' },
    { id: 11, value: '11', name: '11-channel' },
    { id: 12, value: '12', name: '12-channel' },
    { id: 13, value: '13', name: '13-channel' },
    { id: 14, value: '14', name: '14-channel' },
    { id: 15, value: '15', name: '15-channel' }
  ],
  data() {
    return {
      constants: constants,
      timeout: 2500,
      snackbar: false,
      progress: false,
      toggle: 0,
      switch_value: false,
      toggle_exclusive: 2,
      count: 0,
      showingAddForm: false,
      showUpload: false,
      instalation_includes: [],
      film_type: '',
      fields: fields,
      isEditing: false,
      an_exists: false,
      saved: false,
      cannotSave: false,
      value_new: '',
      select_value: '',
      field_value: '',
      show: true,
      showSnackbar: false,
      model: {},
      menu2: '',
      date: ''
      // model: "artwork_location"
      // this.f_field.show
    }
  },
  props: [
    'field',
    'artwork',
    'placeholder',
    'label',
    'name',
    'value',
    'selection',
    'title',
    'film',
    'report',
    'fields_parent'
  ],
  mounted() {
    this.select_value = this.f_artwork[this.f_field.name]
    if (this.f_field == 'type_of_work_id') {
      this.select_value = this.constants.TYPES_OF_WORK(
        this.f_artwork[this.f_field.name]
      ).name
    }
    this.toggle = this.f_artwork[this.f_field.name]
  },
  methods: {
    checkSubfields(event) {
      // console.log('checkSubfields')
      // console.log(event)
      this.select_value = event
      this.saveField(this.select_value)
    },
    location_name(id) {
      if (id > 0) {
        return this.$store.state.locations.find(l => l.id === id).name
      } else {
        return 'Location not found. Probably deleted from CMS.'
      }
    }
  },
  computed: {
    toggle_value() {
      const found = this.f_field.selection.find(f => f.value == this.f_artwork[this.f_field.name])
      return found['name']
    },
    select_item() {
      let item = ''
      if (this.selection_items) {
        item = this.selection_items.find(s => s.id == this.value2)
      }
      return item ? item.name : ''
    },
    // c_user () {
    //   return this.$store.state.user.profile
    // },
    hint() {
      var out = this.f_field.title
      out = out + (this.f_field.hint ? ' - ' + this.f_field.hint : '')
      return out
    },
    value2() {
      // console.log(parseInt(this.f_artwork[this.f_field.related_field],10))
      if (this.f_field.related_field) {
        return parseInt(this.f_artwork[this.f_field.related_field], 10)
      } else {
        return this.f_artwork[this.f_field.name]
      }
    },
    value_radio() {
      // console.log(this.f_artwork[this.f_field.name])
      return this.f_artwork[this.f_field.name]
    },
    dynamic_field_list() {
      if (this.f_field.headline) {
        var c = []
        if (this.report) {
          var fields2 = this.fields_parent
        } else {
          var fields2 = this.fields['tabs'][this.$store.state.currentTab][
            'fields'
          ]
        }
        c = fields2.filter(f => f.dynamic && f.section === this.f_field.section)
        c = c.filter(
          f =>
            f.work_types && f.work_types.includes(this.artwork.classification)
        )
        return c
      } else {
        return []
      }
    },
    field_type() {
      return this.f_field.etype ? this.f_field.etype : this.f_field.ctype
    },
    selection_items() {
      if (this.f_field.table) {
        if (this.f_field.table == 'contacts') {
          var contacts = Object.assign([], this.$store.state.contacts)
          if (this.f_field.column) {
            return contacts.filter(
              c => c[this.f_field.column] == this.f_field.association
            )
          } else {
            return contacts
          }
        }
        else if (this.f_field.table == 'artists') {
          var artists = Object.assign([], this.$store.state.artists)
          if (this.f_field.column) {
            return artists.filter(
              c => c[this.f_field.column] == c[this.f_field.association]
            )
          } else {
            return artists.sort(dynamicSort('name'))
          }
        }
        else if (this.f_field.table == 'artwork_locations') {
          var artwork_locations = Object.assign(
            [],
            this.$store.state.locations
          )
          if (this.f_field.column) {
            return artwork_locations.filter(
              c => c[this.f_field.column] == c[this.f_field.association]
            )
          } else {
            return artwork_locations.sort(dynamicSort('name'))
          }
        }
      }
      else if (this.f_field.constant_selection) {
        console.log('constant')
        var items = Object.assign(
          [],
          this.constants[this.f_field.constant_selection]
        )
        return items
      }
      if (this.f_field.selection && this.f_field.selection.length > 0) {
        return this.f_field.selection
      }
    },
    f_field() {
      var f = this.field
      f.model_string = this.field.model_string
        ? this.field.model_string
        : this.field.name
      f.column = this.field.column ? this.field.column : false
      // console.log(this.f_artwork[this.field.name])
      f.value_string = this.field['model_string']
        ? this[this.field.model_string]
        : this.f_artwork[this.field.name]
      return f
    },
    f_artwork() {
      return this.artwork
    }
  },
  components: {
    OwnershipHistory,
    AddLocation,
    AddArtist,
    Costs,
    ViewArtworks,
    Upload,
    Location,
    Films,
    Audio,
    Light,
    Programme,
    InformationCarrier,
    Electrical,
    ReadingDevices,
    Links,
    Insurance,
    NonElectrical,
    LoanConditions,
    Conservation,
    MarketValueHistory
  }
}
</script>

<style scoped>
li {
  list-style: none;
  margin: 15px 0;
}
code {
  border: 0px;
  color: black;
  box-shadow: none;
  font-family: Arial !important;
  font-weight: 100;
  background: none !important;
  font-size: 16px;
  line-height: 17px;
  margin-top: 0px;
  padding-left: 0px;
}
code::before {
  content: '';
}
label {
  color: rgb(128, 128, 128) !important;
  border-top: 1px solid black;
  margin-top: 0px !important;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/artworks/ReadField.vue